import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a4e345a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "order-info",
  "data-cy": "order-info"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "status" }
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t("COMMON.STATUS")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.t(`ORDER.STATE.${_ctx.order.state.toUpperCase()}`)), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t("ORDER.DATE")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.order.datetimeCreated), 1)
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t("ORDER.TO_PAY")), 1),
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.order.price.value) + " " + _toDisplayString(_ctx.t("CURRENCY.CURRENCY")), 1)
    ]),
    _hoisted_12
  ]))
}